"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactPlayer = _interopRequireDefault(require("react-player"));

var _reactContainerDimensions = _interopRequireDefault(require("react-container-dimensions"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
} // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Locals
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstractions
// ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------

/** Video */


var Video = function Video(props) {
  var givenClassName = props.className,
      style = props.style,
      _props$rawWidth = props.rawWidth,
      rawWidth = _props$rawWidth === void 0 ? 1440 : _props$rawWidth,
      _props$rawHeight = props.rawHeight,
      rawHeight = _props$rawHeight === void 0 ? 900 : _props$rawHeight,
      url = props.url,
      _props$ratio = props.ratio,
      ratio = _props$ratio === void 0 ? rawHeight / rawWidth : _props$ratio;
  return /*#__PURE__*/_react["default"].createElement(_reactContainerDimensions["default"], null, function (_ref) {
    var width = _ref.width;
    var imageHeight = Math.round(width * ratio);
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('video', givenClassName),
      style: _extends({
        height: imageHeight,
        width: '100%'
      }, style)
    }, /*#__PURE__*/_react["default"].createElement(_reactPlayer["default"], {
      url: url,
      width: "inherit",
      height: "inherit",
      controls: true
    }));
  });
}; // ------------------------------------------------------------------------------
// ------------------------------------------------------------------------Typing
// ------------------------------------------------------------------------------


Video.propTypes = process.env.NODE_ENV !== "production" ? {
  url: _propTypes["default"].string,
  rawWidth: _propTypes["default"].number,
  rawHeight: _propTypes["default"].number,
  ratio: _propTypes["default"].number,
  style: _propTypes["default"].object,
  // eslint-disable-line react/forbid-prop-types, react/no-unused-prop-types
  className: _propTypes["default"].string,
  imgStyle: _propTypes["default"].object // eslint-disable-line react/forbid-prop-types, react/no-unused-prop-types

} : {};
Video.defaultProps = {
  rawWidth: 1440,
  rawHeight: 900,
  style: {},
  imgStyle: {},
  className: ''
}; // ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Exports
// ----------------------------------------------------------------------------

var _default = Video;
exports["default"] = _default;
module.exports = exports.default;